import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalEntryDTO  {
    _originalTypeClassName = "zERP.BO.GeneralJournalEntryDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalEntryDTO.translate = translateService;
}
this.Debit = null;
this.Credit = null;
this.Description = null;
this.GeneralJournalEntryDTOKey = null;
this._key = this.GeneralJournalEntryDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Debit:any;
Credit:any;
Description:any;
Account:any;
private _GeneralJournalEntryDTOKey:any;
get GeneralJournalEntryDTOKey(): any {
    return this._GeneralJournalEntryDTOKey;
  }
set GeneralJournalEntryDTOKey(value: any) {
    this._GeneralJournalEntryDTOKey = value;
    this._key = value;
  }
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalEntryDTOKey == null || $this.GeneralJournalEntryDTOKey == 0;
            }


}